import React from 'react';
import './IdeaOfKaddle.css';

const IdeaOfKaddle = () => {
  const handleGoBack = () => {
    window.history.back();
  };

  return (
    <div className="kdl-shell">
      <div className="kdl-container">

        {/* HEADER */}
        <div className="kdl-topbar">
          <svg 
            className="kdl-navicon" 
            onClick={handleGoBack} 
            xmlns="http://www.w3.org/2000/svg" 
            viewBox="0 0 24 24" 
            fill="none" 
            stroke="currentColor" 
            strokeWidth="2"
          >
            <path d="M15 18l-6-6 6-6" strokeLinecap="round"/>
          </svg>
          <span className="kdl-pagetitle">More About Us</span>
        </div>

        {/* TWO COLUMNS */}
        <div className="kdl-layout">

          {/* LEFT — fixed dark panel */}
          <div className="kdl-hero">
            <div>
              <div className="kdl-kicker">Our Story</div>
              <h1 className="kdl-headline">
                Talented people should turn what they know into
                <em> meaningful opportunity.</em>
              </h1>
              <p className="kdl-lede">
                MyKaddle was built around a simple belief — and everything on this platform flows from it.
              </p>
            </div>

            <div className="kdl-footnote">
              <div className="kdl-metrics">
                <div className="kdl-metric">
                  <div className="kdl-dot"></div>
                  <div className="kdl-metrictext">Built for South African tutors and students</div>
                </div>
                <div className="kdl-metric">
                  <div className="kdl-dot"></div>
                  <div className="kdl-metrictext">Fixed 15% commission, no hidden fees</div>
                </div>
                <div className="kdl-metric">
                  <div className="kdl-dot"></div>
                  <div className="kdl-metrictext">Free 30-hour trial on every group joined</div>
                </div>
                <div className="kdl-metric">
                  <div className="kdl-dot"></div>
                  <div className="kdl-metrictext">Human learning first, always</div>
                </div>
              </div>
            </div>
          </div>

          {/* RIGHT — scrollable content */}
          <div className="kdl-scrollzone">

            {/* WHY WE EXIST */}
            <div className="kdl-block">
              <div className="kdl-tag">Why we exist</div>
              <h2 className="kdl-sectiontitle">The problem we set out to solve</h2>
              <div className="kdl-content">
                <p>Across South Africa, many students, graduates, and professionals already help others learn — often informally through WhatsApp groups, PDFs, voice notes, and private sessions. At the same time, unemployment continues to rise, even among capable and educated people.</p>
                <p>We saw an opportunity to bring structure, visibility, and better tools to independent tutors while helping students access learning support from people who truly understand their academic journey.</p>
              </div>
              <div className="kdl-quote">
                <p>MyKaddle exists to make tutoring work more manageable, more scalable, and more rewarding.</p>
              </div>
            </div>

            {/* PLATFORM */}
            <div className="kdl-block">
              <div className="kdl-tag">The platform</div>
              <h2 className="kdl-sectiontitle">Built for tutors and tutees</h2>
              <div className="kdl-content">
                <p>MyKaddle is both a digital learning space and a discovery network for tutors and students.</p>
              </div>
              <div className="kdl-grid">
                <div className="kdl-card">Build a public profile and grow your audience</div>
                <div className="kdl-card">Discover tutors by subject, institution or name</div>
                <div className="kdl-card">Manage learning groups and share study material</div>
                <div className="kdl-card">Join learning groups and attend lessons</div>
                <div className="kdl-card">Host lessons and earn income through knowledge</div>
                <div className="kdl-card">Learn from people who walked your academic path</div>
              </div>
              <div className="kdl-content" style={{marginTop: '16px'}}>
                <p>Many tutors on MyKaddle studied the same CAPS, NSC, IEB, or university courses that students are currently facing. That means students often gain more than just academic help — they gain mentorship, guidance, accountability, and familiarity. Sometimes even in their home language.</p>
              </div>
            </div>

            {/* QUALIFICATIONS */}
            <div className="kdl-block">
              <div className="kdl-tag">Our belief</div>
              <h2 className="kdl-sectiontitle">Qualifications matter — but capability matters too</h2>
              <div className="kdl-content">
                <p>Some of the best teachers are people who deeply understand a subject, communicate clearly, and genuinely care about helping others improve.</p>
              </div>
              <div className="kdl-grid">
                <div className="kdl-card">Qualified educators with formal credentials</div>
                <div className="kdl-card">Proven independent tutors with real teaching ability</div>
              </div>
            </div>

            {/* 15% */}
            <div className="kdl-block">
              <div className="kdl-tag">Transparency</div>
              <h2 className="kdl-sectiontitle">Why we charge 15%</h2>
              <div className="kdl-content">
                <p>MyKaddle takes a fixed 15% commission on tutor earnings. This helps us maintain infrastructure, servers, storage, development, security, and platform operations.</p>
                <p>We want tutors to focus on teaching, not managing complicated systems. That is why many platform tools and resources are made available directly inside the app at no additional cost.</p>
              </div>
              <div className="kdl-stack">
                <div className="kdl-card">Tutor groups receive unlimited storage for study materials</div>
                <div className="kdl-card">Tutors gain access to a built-in discovery network</div>
                <div className="kdl-card">Payments and wallets are managed securely in one place</div>
                <div className="kdl-card">There is no cap on how much tutors can earn</div>
              </div>
            </div>

            {/* HUMAN LEARNING */}
            <div className="kdl-block">
              <div className="kdl-tag">Our vision</div>
              <h2 className="kdl-sectiontitle">Human learning first</h2>
              <div className="kdl-content">
                <p>Technology will continue to shape education, and MyKaddle plans to introduce AI-powered tools in the future. But our vision is different from replacing tutors.</p>
              </div>
              <div className="kdl-banner">
                <p>We believe <span>technology should support educators, not remove them.</span> Real tutors provide accountability, structure, explanation, mentorship, emotional support, and human understanding. AI may assist the experience — but people remain at the center of learning.</p>
              </div>
            </div>

            {/* HOW IT WORKS */}
            <div className="kdl-block">
              <div className="kdl-tag">How it works</div>
              <h2 className="kdl-sectiontitle">For students</h2>
              <div className="kdl-content">
                <p>Students may join up to 3 groups. Each newly joined group includes a free 30-hour access period during which students can attend lessons, review study materials, ask tutors questions, and evaluate whether the learning environment suits them.</p>
                <p>After the trial period, students may decide whether they want to continue through a paid subscription. If you cannot find a tutor or subject you need, contact support or use the "Include Subject" option inside the support section.</p>
              </div>
            </div>

            {/* COMMUNITY */}
            <div className="kdl-block">
              <div className="kdl-tag">Community</div>
              <h2 className="kdl-sectiontitle">Transparency and growth</h2>
              <div className="kdl-content">
                <p>We want MyKaddle to feel like a platform built with its community, not simply for it. Tutors will periodically receive platform reports covering growth, activity, feedback, and engagement trends.</p>
                <p>We also plan to introduce annual tutor achievement certificates based on tutoring hours, student reach, engagement, and consistency — recognizing the effort tutors invest into helping others learn.</p>
              </div>
            </div>

            {/* FINAL */}
            <div className="kdl-block">
              <div className="kdl-tag">A final word</div>
              <h2 className="kdl-sectiontitle">Smart people deserve opportunity</h2>
              <div className="kdl-outro">
                <p>Whether you are teaching, learning, mentoring, or building your future —</p>
                <p><strong>we hope this platform helps you move forward.</strong></p>
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>
  );
};

export default IdeaOfKaddle;